import React, { useEffect } from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { SubmitError } from 'Components/Fields/SubmitError';
import { FormField } from 'Components/HookFormFields/FormField';
import { useForm } from 'Hooks/useForm';
import { password, email, compareNewEmail, compareConfirmEmail, asyncValidateExistingUser } from 'Utils/FormValidation';
import './EditEmailAddressModal.css';

export const EditEmailAddressModal = ({ onFormSubmit }) => {
  const formName = 'updateEmailAddressForm';

  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  return (
    <div>
      <div className="modalTitle">Update Email Address</div>
      <form className="editEmailForm" onSubmit={(event) => handleSubmit(event)}>
        <FormField
          name="newEmailAddress"
          label="New Email Address"
          component="EmailField"
          validate={[compareConfirmEmail]}
          validateOnBlur={[email]}
          validateDebounceTime={600}
          asyncValidate={[asyncValidateExistingUser]}
          asyncValidateOnBlur={[asyncValidateExistingUser]}
          autoValidate
          {...formFieldProps}
        />
        <FormField
          name="confirmNewEmailAddress"
          label="Confirm New Email Address"
          component="EmailField"
          validate={[compareNewEmail]}
          validateOnBlur={[email]}
          validateDebounceTime={600}
          asyncValidate={[asyncValidateExistingUser]}
          asyncValidateOnBlur={[asyncValidateExistingUser]}
          autoValidate
          {...formFieldProps}
        />
        <FormField
          name="password"
          label="Password"
          component="PasswordField"
          validate={[password]}
          validateOnBlur={[password]}
          {...formFieldProps}
        />
        <SubmitError error={formError} formName={formName} />
        <div className="submitButtonContainer">
          <SubmitButton text="Update Email Address" submitting={submitting} mockDisabled={submitDisabled} />
        </div>
      </form>
    </div>
  );
};
